export const fontFamilyStack = '"VerlagNormal", "Avenir Next", "Avenir", "Helvetica Neue", "Helvetica", sans-serif';

export const textColor = '#363820';
export const linkColor = '#457c79';
export const backgroundColor = '#fbfbfb';
export const gray1 = '#f0f0f3';

export const mqRuleAboveMobile = 'only screen and (min-width: 667px)';



// WEBPACK FOOTER //
// ./src/styles.js